

import React, { Component } from 'react';

import { createPortal } from 'react-dom';

const APPEND_CONTAINER_ID = 'body-append-container';





class AppendedToBody extends Component {


  constructor() {
    super();

    const container = document.getElementById(APPEND_CONTAINER_ID);

    if (container) {
      this._appendContainer = container;

      return;
    }

    const div = document.createElement('div');

    div.setAttribute('id', APPEND_CONTAINER_ID);

    this._appendContainer = div;

    // $FlowFixMe this is never going to be falsy
    document.body.appendChild(div);
  }

  render() {
    const { children } = this.props;

    /* istanbul ignore next */
    if (!this._appendContainer) {return null;}

    return createPortal(children, this._appendContainer);
  }
}

export default function appendToBody(WrappedComponent) {
  return (props) =>
  <AppendedToBody>
      <WrappedComponent {...props} />
    </AppendedToBody>;

}